import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "equity-content" }
const _hoisted_2 = {
  key: 0,
  class: "current-equity-card"
}
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "badge" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "discount-display" }
const _hoisted_7 = { class: "discount-number" }
const _hoisted_8 = { class: "equity-info" }
const _hoisted_9 = { class: "order-count" }
const _hoisted_10 = { class: "copywriting" }
const _hoisted_11 = { class: "equity-levels" }
const _hoisted_12 = { class: "section-title" }
const _hoisted_13 = { class: "levels-grid" }
const _hoisted_14 = {
  key: 0,
  class: "level-tag"
}
const _hoisted_15 = { class: "level-header" }
const _hoisted_16 = { class: "level-icon" }
const _hoisted_17 = { class: "level-discount" }
const _hoisted_18 = { class: "level-body" }
const _hoisted_19 = { class: "level-requirement" }
const _hoisted_20 = { class: "level-desc" }
const _hoisted_21 = { class: "order-history" }
const _hoisted_22 = { class: "section-title" }
const _hoisted_23 = { class: "order-number" }
const _hoisted_24 = { class: "price" }
const _hoisted_25 = { class: "pay-time" }

import { ref, watch } from 'vue';
import { Trophy, Medal, Star, List } from '@element-plus/icons-vue';
import { getDiscountGear, getUserDiscount, getOrderList } from '@/api/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderHistory',
  props: {
    visible: { type: Boolean }
  },
  emits: ['update:visible'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogVisible = ref(props.visible);
const loading = ref(false);
const discountGears = ref<any[]>([]);
const userDiscount = ref<any>(null);
const orderList = ref<any[]>([]);

watch(() => props.visible, (val) => {
  dialogVisible.value = val;
  if (val) {
    fetchAllData();
  }
});

const handleClose = () => {
  emit('update:visible', false);
};

// 获取所有数据
const fetchAllData = async () => {
  loading.value = true;
  try {
    await Promise.all([
      fetchDiscountGear(),
      fetchUserDiscount(),
      fetchOrderList()
    ]);
  } catch (error) {
    console.error('获取权益信息失败:', error);
  } finally {
    loading.value = false;
  }
};

// 获取权益档位列表
const fetchDiscountGear = async () => {
  try {
    const response = await getDiscountGear();
    if (response.data && response.data.code === 0) {
      discountGears.value = response.data.data || [];
    }
  } catch (error) {
    console.error('获取权益档位失败:', error);
  }
};

// 获取用户当前档位
const fetchUserDiscount = async () => {
  try {
    const response = await getUserDiscount();
    if (response.data && response.data.code === 0) {
      userDiscount.value = response.data.data;
    }
  } catch (error) {
    console.error('获取用户档位失败:', error);
  }
};

// 获取历史订单
const fetchOrderList = async () => {
  try {
    const response = await getOrderList();
    if (response.data && response.data.code === 0) {
      orderList.value = response.data.data || [];
    }
  } catch (error) {
    console.error('获取订单列表失败:', error);
  }
};

// 格式化折扣显示
const formatDiscount = (discount: number) => {
  if (!discount) return '10';
  return (discount * 10).toFixed(1);
};

// 格式化时间
const formatTime = (time: string) => {
  if (!time) return '-';
  return time;
};

// 判断是否是当前档位
const isCurrentLevel = (gear: any) => {
  return userDiscount.value && gear.orderNum === userDiscount.value.orderNum;
};

// 判断是否已达到该档位
const isReachedLevel = (gear: any) => {
  if (!userDiscount.value) return false;
  return gear.orderNum <= userDiscount.value.orderNum;
};

// 获取支付类型文本
const getPaymentType = (type: number) => {
  const typeMap: Record<number, string> = {
    0: '支付宝',
    1: '微信',
    2: '支付宝',
    3: '微信',
    99: '激活码',
  };
  return typeMap[type] || '未知';
};

// 获取支付类型标签颜色
const getPaymentTagType = (type: number) => {
  const tagTypeMap: Record<number, string> = {
    0: 'primary',
    1: 'success',
    2: 'primary',
    3: 'success',
    99: 'warning',
  };
  return tagTypeMap[type] || 'info';
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "我的权益",
    width: "90%",
    style: { maxWidth: '1100px' },
    onClose: handleClose,
    "close-on-click-modal": false,
    class: "equity-dialog",
    top: "8vh"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (userDiscount.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_icon, { class: "crown-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Trophy))
                    ]),
                    _: 1
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "当前权益", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(formatDiscount(userDiscount.value.discount)), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "discount-unit" }, "折", -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createTextVNode("已完成 ")),
                    _createElementVNode("strong", null, _toDisplayString(orderList.value.length), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" 单"))
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(userDiscount.value.copywriting), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", _hoisted_12, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Medal))
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "权益档位", -1))
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discountGears.value, (gear, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["level-card", { 'active': isCurrentLevel(gear), 'reached': isReachedLevel(gear) }])
              }, [
                (isCurrentLevel(gear))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "当前档位"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Star))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(formatDiscount(gear.discount)) + "折", 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, "满 " + _toDisplayString(gear.orderNum) + " 单", 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(gear.copywriting), 1)
                ])
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("h3", _hoisted_22, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(List))
              ]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "历史订单", -1))
          ]),
          _createVNode(_component_el_table, {
            data: orderList.value,
            style: {"width":"100%"},
            class: "order-table",
            "empty-text": "暂无订单记录",
            "max-height": "280"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "orderNumber",
                label: "订单号",
                "min-width": "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(scope.row.orderNumber), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "price",
                label: "订单金额",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_24, "¥" + _toDisplayString(scope.row.price), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "type",
                label: "支付类型",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    type: getPaymentTagType(scope.row.type),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getPaymentType(scope.row.type)), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "payTime",
                label: "支付时间",
                "min-width": "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(formatTime(scope.row.payTime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})